import { createContext, useContext, useEffect, useState } from "react";
import { storedLang, saveLang } from "@/lib/errors";
import { formatApiErrorDetail } from "@/lib/api";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(storedLang);

  useEffect(() => {
    document.documentElement.lang = lang === "en" ? "en" : "nb";
  }, [lang]);

  const setLang = (l) => {
    saveLang(l);
    setLangState(l);
  };

  const value = {
    lang,
    setLang,
    locale: lang === "en" ? "en-GB" : "nb-NO",
    t: (no, en) => (lang === "en" ? en : no),
    err: (detail, fallbackNo, fallbackEn) =>
      detail == null && fallbackNo ? (lang === "en" ? fallbackEn : fallbackNo) : formatApiErrorDetail(detail),
  };
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
